import classes from '../classes';
export default function reactBaseStyles() {
  return {
    className: classes.apply(void 0, arguments)
  };
}